import { useRouter } from 'vue-router';
import QRouter from '~/services/qRouter';

function useQRouter(): QRouter {
  // eslint-disable-next-line quizizz/no-vue-composable-router
  const router = useRouter();
  const qRouter = QRouter.getInstance(router);

  return qRouter;
}

export default useQRouter;
